import store from "store";

/**
 * Guard de Vue Router pra bloquear acesso a uma rota baseado em feature
 * do plano do usuario.
 *
 * Espelha (a nivel de UX) o que o middleware backend `requireFeature`
 * faz. A trava REAL continua sendo o backend devolvendo 403 — este
 * guard apenas evita carregar a view e redireciona pra /upgrade.
 *
 * Se features ainda nao carregaram (state.features === null), libera
 * por padrao pra evitar flicker. O backend cuida caso o user tente
 * chamar API.
 */
const hasFeature = (featureName) => (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    return next('/login');
  }

  // Admin de plataforma bypassa
  if (store.getters.isManagement) {
    return next();
  }

  // Se features ainda nao foram resolvidas, libera (evita flicker
  // entre AUTHENTICATE e LOAD_FEATURES). O backend continua sendo trava.
  const features = store.state.auth.features;
  if (features === null || features === undefined) {
    return next();
  }

  if (features[featureName] === true) {
    return next();
  }

  return next({ path: '/upgrade', query: { feature: featureName, redirect: to.fullPath } });
};

export default hasFeature;
